module.exports = __webpack_public_path__ + "img/p10.0684768a.png";